import { useNavigate } from '@tanstack/react-router'
import type { ReactNode } from 'react'

function BrandPanel({ title, sub }: { title: string; sub: string }) {
  const navigate = useNavigate()
  return (
    <div
      style={{
        position: 'relative',
        overflow: 'hidden',
        background: 'var(--surface-emerald)',
        color: 'var(--text-on-emerald)',
        padding: 'clamp(36px,5vw,56px)',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        minHeight: 480,
      }}
    >
      <div
        aria-hidden="true"
        style={{
          position: 'absolute',
          inset: 0,
          backgroundImage: "url('/assets/zellij-tile.svg')",
          backgroundSize: '120px 120px',
          opacity: 0.12,
        }}
      />
      <a
        href="/"
        onClick={(e) => {
          e.preventDefault()
          navigate({ to: '/' })
        }}
        style={{
          position: 'relative',
          display: 'flex',
          alignItems: 'center',
          gap: 10,
          textDecoration: 'none',
        }}
      >
        <img src="/assets/oumma-mark-gold.svg" alt="" width="34" height="34" />
        <span
          style={{
            fontFamily: 'var(--font-display)',
            fontWeight: 700,
            fontSize: 26,
            color: 'var(--paper-0)',
          }}
        >
          Oumma
        </span>
      </a>
      <div style={{ position: 'relative' }}>
        <h2
          style={{
            fontSize: 'var(--text-h2)',
            color: 'var(--paper-0)',
            margin: '0 0 14px',
            lineHeight: 1.15,
          }}
        >
          {title}
        </h2>
        <p
          style={{
            fontSize: 'var(--text-lead)',
            color: 'var(--emerald-100)',
            maxWidth: 360,
            margin: 0,
          }}
        >
          {sub}
        </p>
      </div>
      <div
        style={{
          position: 'relative',
          fontFamily: 'var(--font-mono)',
          fontSize: 13.5,
          color: 'var(--gold-200)',
        }}
      >
        Assalamu alaikum — bienvenue
      </div>
    </div>
  )
}

/** Two-column auth shell: emerald brand panel + form area. */
export default function AuthLayout({
  panelTitle,
  panelSub,
  children,
}: {
  panelTitle: string
  panelSub: string
  children: ReactNode
}) {
  return (
    <div
      style={{
        maxWidth: 980,
        margin: '0 auto',
        padding: 'var(--space-12) var(--gutter) var(--space-20)',
      }}
    >
      <div
        className="oumma-auth-grid"
        style={{
          display: 'grid',
          gridTemplateColumns: '1fr 1fr',
          overflow: 'hidden',
          borderRadius: 'var(--radius-xl)',
          border: '1px solid var(--border-soft)',
          boxShadow: 'var(--shadow-lg)',
        }}
      >
        <BrandPanel title={panelTitle} sub={panelSub} />
        <div
          style={{
            background: 'var(--surface-card)',
            padding: 'clamp(32px,4vw,52px)',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
          }}
        >
          {children}
        </div>
      </div>
    </div>
  )
}
